// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6x-0";
export var startPickingButton = "_6x-1";